import React from 'react';
import TierPromotionCardSemiDumb from '../../../../DeviationViews/TierPromotionCardSemiDumb';
import s from './Tier.scss';
const TierThumbReactView = ({ deviation, width, height })=>/*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement(TierPromotionCardSemiDumb, {
        width: width,
        height: height,
        deviation: deviation,
        ctaButton: "subscribe"
    }));
TierThumbReactView.displayName = 'TierThumbReactView';
export default TierThumbReactView;

//# sourceMappingURL=Tier.js.map